import React from "react";
import Banner from "./components/Banner";
import Home from "./screens/Home";

function Dashboard() {
  return (
    <div>
      <Banner />
      <Home />
    </div>
  );
}

export default Dashboard;
